import React from 'react'
import Grid from '@material-ui/core/Grid'
import styled from 'styled-components'
import {Draggable, DraggableProvidedDraggableProps} from 'react-beautiful-dnd'
import CountDownTimer, {
  CountDownTimerSettings,
} from 'Event/Dashboard/components/CountDownTimer'
import {Editable} from 'Event/Dashboard/editor/views/EditComponent'
import {useEditMode} from 'Event/EditModeProvider'
import {DraggableOverlay} from 'lib/ui/drag-and-drop'
import {useToggle} from 'lib/toggle'
import CountDownTimerConfig from 'Event/Dashboard/components/CountDownTimer/CountDownTimerConfig'

type CountDownTimerProps = {
  id: string
  countDownTimer: CountDownTimerSettings
  index: number
  onRender?: () => void
}

export default React.memo((props: CountDownTimerProps) => {
  const isEditMode = useEditMode()
  const {flag: configVisible, toggle: toggleConfig} = useToggle()

  const countDownTimer = (
    <CountDownTimer
      {...props.countDownTimer}
      id={props.id}
      onRender={props.onRender}
    />
  )

  if (!isEditMode) {
    return <CountDownTimerContainer>{countDownTimer}</CountDownTimerContainer>
  }

  return (
    <>
      <CountDownTimerConfig
        showing={configVisible}
        onClose={toggleConfig}
        id={props.id}
        keyPath={`countDownTimers.${props.id}`}
        countDownTimer={props.countDownTimer}
      />
      <Draggable draggableId={props.id} index={props.index}>
        {(provided) => (
          <CountDownTimerContainer
            ref={provided.innerRef}
            draggableProps={provided.draggableProps}
          >
            <DraggableOverlay>
              <Editable
                onEdit={toggleConfig}
                handleProps={provided.dragHandleProps}
              >
                <>{countDownTimer}</>
              </Editable>
            </DraggableOverlay>
          </CountDownTimerContainer>
        )}
      </Draggable>
    </>
  )
})

const CountDownTimerContainer = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactElement
    draggableProps?: DraggableProvidedDraggableProps
  }
>((props, ref) => {
  return (
    <>
      <StyledGrid item xs={12} ref={ref} {...props.draggableProps}>
        {props.children}
      </StyledGrid>
    </>
  )
})

const StyledGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
`
